import { InjectionToken } from '@angular/core';
import { InitializableInterface } from './initializable.interface';
import { Observable } from 'rxjs';

export interface SideMenuInterface extends InitializableInterface {
    init(): Observable<void>;
}

export const SideMenuInstanceToken = new InjectionToken<SideMenuInterface>('SideMenuInterface');
